import React from "react"
import {Route, Redirect} from "react-router-dom"
import {connect} from "react-redux"
import PropTypes from "prop-types"

const UserRoute = ({isAuthenticated, component: Component, ...rest}) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
    }
  />
)

UserRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired
}

const mapStateToProps = ({auth}) => {
  const {isAuthenticated} = auth
  return {
    isAuthenticated
  }
}

export default connect(mapStateToProps)(UserRoute)



// WEBPACK FOOTER //
// ./src/components/routes/UserRoute.js